const styles = (theme) => ({
  datePickerLabel: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular,
  },
  popoverButton: {
    textTransform: 'inherit',
  },
  inlineEditRoot: {
    minWidth: 140,
  },
});

export default styles;
